import $ from "jquery";

class Languages {
  // 1.- Describe and create/initate our object
  constructor() {      

    //ibdsf_top_left_logo
    this.ibdsf_top_left_logo = $("#ibdsf_top_left_logo");
      
    //MenuItems Ids
    this.homeMenuLink = $("#homeMenuLink");
    this.aboutUsMenuLink = $("#aboutUsMenuLink");
    this.servicesMenuLink = $("#servicesMenuLink");
    this.individualTherapyMenuLink = $("#individualTherapyMenuLink");
    this.testimonialsMenuLink = $("#testimonialsMenuLink");
    this.contactMenuLink = $("#contactMenuLink");
    this.languagesMenuLink = $("#languagesMenuLink");
    this.EnglishlanguageMenuLink = $("#EnglishlanguageMenuLink");
    this.HebrewlanguageMenuLink = $("#HebrewlanguageMenuLink");
    this.SpanishlanguageMenuLink = $("#SpanishlanguageMenuLink");
    

    //PageBanner Text
    this.pageBannerText = $("#page-banner-text");

    //Middle Section Headers
    this.middleSectionHeaderAllied = $("#middleSectionHeaderAllied");
    this.middleSectionHeaderPatients = $("#middleSectionHeaderPatients");
    this.middleSectionHeaderPayers = $("#middleSectionHeaderPayers");

    //Middle Section Body
    this.middleSectionBodyAllied = $("#middleSectionBodyAllied");
    this.middleSectionBodyPatients = $("#middleSectionBodyPatients");
    this.middleSectionBodyPayers = $("#middleSectionBodyPayers");

    this.middleSectionFootAlliedLink = $("#middleSectionFootAlliedLink");
    this.middleSectionFootPatientsLink = $("#middleSectionFootPatientsLink");
    this.middleSectionFootPayersLink = $("#middleSectionFootPayersLink");

    //Middle Section Foot
    this.middleSectionFootAllied = $("#middleSectionFootAllied");
    this.middleSectionFootPatients = $("#middleSectionFootPatients");
    this.middleSectionFootPayers = $("#middleSectionFootPayers");

    //HEader SignIn ButtonImage
    this.ImgSignInButton = $("#ImgSignInButton");

    //Learn How we can help Button main page
    this.ImgLearnHowWeCanHelp = $("#ImgLearnHowWeCanHelp");

    //Middle Section ImgGetStartedNowButton
    this.ImgGetStartedNowButtonAllied = $("#ImgGetStartedNowButtonAllied");
    this.ImgGetStartedNowButtonPatients = $("#ImgGetStartedNowButtonPatients");
    this.ImgGetStartedNowButtonPayers = $("#ImgGetStartedNowButtonPayers");

    //Footer Connect
    this.footerConnect = $("#footerConnect");

    //Page Content
    this.pageContent = $("#pageContent");

    //PageBanner
    this.pageBannerAboutUsTitle = $("#pageBannerAboutUsTitle");    
    this.pageBannerAlliedTitle = $("#pageBannerAlliedTitle");
    this.pageBannerPatientsTitle = $("#pageBannerPatientsTitle");
    this.pageBannerPayersTitle = $("#pageBannerPayersTitle");
    this.pageBannerPayersIntroTitle = $("#pageBannerPayersIntroTitle");
    this.pageBannerContactUsTitle = $("#pageBannerContactUsTitle");  
    this.pageBannerTherapyTitle = $("#pageBannerTherapyTitle");

    //About Us Content
    this.AboutUsText1 = $("#AboutUsText1");
    this.AboutUsText2 = $("#AboutUsText2");
    this.AboutUsText3 = $("#AboutUsText3");
    this.AboutUsText4 = $("#AboutUsText4");
    this.AboutUsText5 = $("#AboutUsText5");
    this.AboutUsText6 = $("#AboutUsText6");
    this.AboutUsText7 = $("#AboutUsText7");

    //Allied Content
    this.alliedContentText1 = $("#alliedContentText1");
    this.alliedContentText2 = $("#alliedContentText2");
    this.alliedContentText3 = $("#alliedContentText3");
    this.alliedContentText4 = $("#alliedContentText4");
    this.alliedContentText5 = $("#alliedContentText5");
    this.alliedContentText6 = $("#alliedContentText6");
    this.alliedContentText7 = $("#alliedContentText7");
    this.alliedContentText8 = $("#alliedContentText8");
    this.alliedContentText9 = $("#alliedContentText9");
    this.alliedContentText10 = $("#alliedContentText10");
    this.alliedContentText11 = $("#alliedContentText11");
    this.alliedContentText12 = $("#alliedContentText12");

    //Patients Content
    this.patientsContentText1 = $("#patientsContentText1");
    this.patientsContentText2 = $("#patientsContentText2");
    this.patientsContentText3 = $("#patientsContentText3");
    this.patientsContentText4 = $("#patientsContentText4");
    this.patientsContentText5 = $("#patientsContentText5");
    this.patientsContentText6 = $("#patientsContentText6");
    this.patientsContentText7 = $("#patientsContentText7");
    this.patientsContentText8 = $("#patientsContentText8");
    this.patientsContentText9 = $("#patientsContentText9");
    this.patientsContentText10 = $("#patientsContentText10");
    this.patientsContentText11 = $("#patientsContentText11");
    this.patientsContentText12 = $("#patientsContentText12");
    this.patientsContentText13 = $("#patientsContentText13");

    //Payers Content
    this.payersContentText1 = $("#payersContentText1");
    this.payersContentText2 = $("#payersContentText2");
    this.payersContentText3 = $("#payersContentText3");
    this.payersContentText4 = $("#payersContentText4");
    this.payersContentText5 = $("#payersContentText5");
    this.payersContentText6 = $("#payersContentText6");
    this.payersContentText7 = $("#payersContentText7");
    this.payersContentText8 = $("#payersContentText8");
    this.payersContentText9 = $("#payersContentText9");
    this.payersContentText10 = $("#payersContentText10");

    //Therapy content
    this.therapyContentText1 = $("#therapyContentText1");
    this.therapyContentText2 = $("#therapyContentText2");
    this.therapyContentText3 = $("#therapyContentText3");
    this.therapyContentText4 = $("#therapyContentText4");
    this.therapyContentText5 = $("#therapyContentText5");
    this.therapyContentText6 = $("#therapyContentText6");
    this.therapyContentText7 = $("#therapyContentText7");
    this.therapyContentText8 = $("#therapyContentText8");
    this.therapyContentText9 = $("#therapyContentText9");
    this.therapyContentText10 = $("#therapyContentText10");
    this.therapyContentText11 = $("#therapyContentText11");
    this.therapyContentText12 = $("#therapyContentText12");
    this.therapyContentText13 = $("#therapyContentText13");
    this.therapyContentText14 = $("#therapyContentText14");
    this.therapyContentText15 = $("#therapyContentText15");
    this.therapyContentText16 = $("#therapyContentText16");
    this.therapyContentText17 = $("#therapyContentText17");
    this.therapyContentText18 = $("#therapyContentText18");

    //Message System
    this.form_container = $("#form_container");
    this.messageSystemText1 = $("#messageSystemText1");
    this.messageSystemText2 = $("#messageSystemText2");
    this.messageSystemText3 = $("#messageSystemText3");
    this.messageSystemText4 = $("#messageSystemText4");
    this.messageSystemText5 = $("#messageSystemText5");
    this.SendMessage = $("#SendMessage");


    this.languagesJSON = require('../../Languages.json');      
    this.chooseLanguage();         
  }

  // 2.- events
  chooseLanguage() {
    
    this.EnglishlanguageMenuLink.on("click", this.reloadPageEng.bind());    
    this.HebrewlanguageMenuLink.on("click", this.reloadPageHeb.bind());    
    this.SpanishlanguageMenuLink.on("click", this.reloadPageSpa.bind());
    
    // this.EnglishlanguageMenuLink.prop("href", url);
    // this.HebrewlanguageMenuLink.prop("href", url+"#he");   
    

    // Check if a hash value exists in the URL
    if (window.location.hash) {      
        if (window.location.hash == "#he") {

            //Top Left IBDSF Logo
            this.ibdsf_top_left_logo.prop("href", this.homeMenuLink.attr("href")+"#he");

            //MenuItems--------------------------------------------------
            this.homeMenuLink.text(this.languagesJSON.he.MenuLinks.homeMenuLink);
            this.homeMenuLink.prop("href", this.homeMenuLink.attr("href")+"#he");

            this.aboutUsMenuLink.text(this.languagesJSON.he.MenuLinks.aboutUsMenuLink);
            this.aboutUsMenuLink.prop("href", this.aboutUsMenuLink.attr("href")+"#he");

            this.servicesMenuLink.text(this.languagesJSON.he.MenuLinks.servicesMenuLink);            

            this.individualTherapyMenuLink.text(this.languagesJSON.he.MenuLinks.individualTherapyMenuLink);
            this.individualTherapyMenuLink.prop("href", this.individualTherapyMenuLink.attr("href")+"#he");

            this.testimonialsMenuLink.text(this.languagesJSON.he.MenuLinks.testimonialsMenuLink);
            this.testimonialsMenuLink.prop("href", this.testimonialsMenuLink.attr("href")+"#he");

            this.contactMenuLink.text(this.languagesJSON.he.MenuLinks.contactMenuLink);
            this.contactMenuLink.prop("href", this.contactMenuLink.attr("href")+"#he");

            this.languagesMenuLink.text(this.languagesJSON.he.MenuLinks.language);
            this.EnglishlanguageMenuLink.text(this.languagesJSON.he.MenuLinks.hebrewLang);
            this.HebrewlanguageMenuLink.text(this.languagesJSON.he.MenuLinks.englishLang);
            this.SpanishlanguageMenuLink.text(this.languagesJSON.he.MenuLinks.spanishLang);
          
            //PageBannerText--------------------------------------------------
            this.pageBannerText.html("<h2 class='headline--medium'>"+ 
              this.languagesJSON.he.pageBannerText.text1 + 
                "</br>"+
              this.languagesJSON.he.pageBannerText.text2 + 
                "</br>" + 
              this.languagesJSON.he.pageBannerText.text3 + 
                "</br>" + 
                this.languagesJSON.he.pageBannerText.text4 + 
                "</br>" + 
                this.languagesJSON.he.pageBannerText.text5 + 
              " </h2>");

            //Middle Section Header
              this.middleSectionHeaderAllied.html("<p style='font-size:1.3em' class='t-center'>" + this.languagesJSON.he.middleSectionHeader.allied + "</p>");
              this.middleSectionHeaderPatients.html("<p style='font-size:1.3em' class='t-center'>" + this.languagesJSON.he.middleSectionHeader.patients + "</p>");
              this.middleSectionHeaderPayers.html("<p style='font-size:1.3em' class='t-center'>" + this.languagesJSON.he.middleSectionHeader.payers.text1 + "</br>" + this.languagesJSON.he.middleSectionHeader.payers.text2 + "</p>");


            //Middle Section Body
              this.middleSectionBodyAllied.attr("dir","rtl");
              this.middleSectionBodyAllied.html("<p>" + this.languagesJSON.he.middleSectionBody.allied.text1 + "</p><br><br><p>" + this.languagesJSON.he.middleSectionBody.allied.text2 + "</p>");

              this.middleSectionBodyPatients.attr("dir","rtl");
              this.middleSectionBodyPatients.html("<p>" + this.languagesJSON.he.middleSectionBody.patients.text1 + "</p><br><br><p>" + this.languagesJSON.he.middleSectionBody.patients.text2 + "</p><br><br><p>" + this.languagesJSON.he.middleSectionBody.patients.text3 + "</p>");
              
              this.middleSectionBodyPayers.attr("dir","rtl");
              this.middleSectionBodyPayers.html("<p>" + this.languagesJSON.he.middleSectionBody.payers.text1 + "</p><br><br><p>" + this.languagesJSON.he.middleSectionBody.payers.text2 + "</p>");
              
              this.middleSectionFootAlliedLink.prop("href", this.middleSectionFootAlliedLink.attr("href")+"#he");
              this.middleSectionFootPatientsLink.prop("href", this.middleSectionFootPatientsLink.attr("href")+"#he");
              this.middleSectionFootPayersLink.prop("href", this.middleSectionFootPayersLink.attr("href")+"#he");

            //Middle Section Footer
            this.middleSectionFootAllied.attr("dir","rtl");
            this.middleSectionFootAllied.html(this.languagesJSON.he.middleSectionFoot.allied.text1);

            this.middleSectionFootPatients.attr("dir","rtl");
            this.middleSectionFootPatients.html(this.languagesJSON.he.middleSectionFoot.patients.text1);

            this.middleSectionFootPayers.attr("dir","rtl");
            this.middleSectionFootPayers.html(this.languagesJSON.he.middleSectionFoot.payers.text1);

            //Footer Connect
            this.footerConnect.attr("dir","rtl");
            this.footerConnect.html(this.languagesJSON.he.Footer.connect);

            //Page Content
            this.pageContent.attr("dir","rtl");

            //Page Banner
            this.pageBannerAboutUsTitle.html(this.languagesJSON.he.PageBanner.aboutUs.text1);
            this.pageBannerAlliedTitle.html(this.languagesJSON.he.PageBanner.allied.text1 + "</br>&nbsp;" + this.languagesJSON.he.PageBanner.allied.text2);
            this.pageBannerPatientsTitle.html(this.languagesJSON.he.PageBanner.patients.text1);
            this.pageBannerPayersTitle.html(this.languagesJSON.he.PageBanner.payers.text1 + " &nbsp;</br>&nbsp;" + this.languagesJSON.he.PageBanner.payers.text2);
            this.pageBannerPayersIntroTitle.html(this.languagesJSON.he.PageBanner.payers.text3);

            this.pageBannerContactUsTitle.html(this.languagesJSON.he.PageBanner.contactus.text1);
            this.pageBannerContactUsTitle.attr("dir","rtl");
           
            this.pageBannerTherapyTitle.html(this.languagesJSON.he.PageBanner.therapy.text1);
            this.pageBannerTherapyTitle.attr("dir","rtl");
            

            //AboutUs
            this.AboutUsText1.html(this.languagesJSON.he.PageContent.aboutUs.AboutUsText1);
            this.AboutUsText2.html(this.languagesJSON.he.PageContent.aboutUs.AboutUsText2);
            this.AboutUsText3.html(this.languagesJSON.he.PageContent.aboutUs.AboutUsText3);
            this.AboutUsText4.html(this.languagesJSON.he.PageContent.aboutUs.AboutUsText4);
            this.AboutUsText5.html(this.languagesJSON.he.PageContent.aboutUs.AboutUsText5);
            this.AboutUsText6.html(this.languagesJSON.he.PageContent.aboutUs.AboutUsText6);
            this.AboutUsText7.html(this.languagesJSON.he.PageContent.aboutUs.AboutUsText7);

            //Allied Content
            this.alliedContentText1.html(this.languagesJSON.he.PageContent.allied.text1);
            this.alliedContentText2.html(this.languagesJSON.he.PageContent.allied.text2);
            this.alliedContentText3.html(this.languagesJSON.he.PageContent.allied.text3);
            this.alliedContentText4.html(this.languagesJSON.he.PageContent.allied.text4);
            this.alliedContentText5.html(this.languagesJSON.he.PageContent.allied.text5);
            this.alliedContentText6.html(this.languagesJSON.he.PageContent.allied.text6);
            this.alliedContentText7.html(this.languagesJSON.he.PageContent.allied.text7);
            this.alliedContentText8.html(this.languagesJSON.he.PageContent.allied.text8);
            this.alliedContentText9.html(this.languagesJSON.he.PageContent.allied.text9);
            this.alliedContentText10.html(this.languagesJSON.he.PageContent.allied.text10);
            this.alliedContentText11.html(this.languagesJSON.he.PageContent.allied.text11);
            this.alliedContentText12.html(this.languagesJSON.he.PageContent.allied.text12);


            //Patients Content 
            this.patientsContentText1.html(this.languagesJSON.he.PageContent.patients.text1);
            this.patientsContentText2.html(this.languagesJSON.he.PageContent.patients.text2);
            this.patientsContentText3.html(this.languagesJSON.he.PageContent.patients.text3);
            this.patientsContentText4.html(this.languagesJSON.he.PageContent.patients.text4);
            this.patientsContentText5.html(this.languagesJSON.he.PageContent.patients.text5);
            this.patientsContentText6.html(this.languagesJSON.he.PageContent.patients.text6);
            this.patientsContentText7.html(this.languagesJSON.he.PageContent.patients.text7);
            this.patientsContentText8.html(this.languagesJSON.he.PageContent.patients.text8);
            this.patientsContentText9.html(this.languagesJSON.he.PageContent.patients.text9);
            this.patientsContentText10.html(this.languagesJSON.he.PageContent.patients.text10);
            this.patientsContentText11.html(this.languagesJSON.he.PageContent.patients.text11);
            this.patientsContentText12.html(this.languagesJSON.he.PageContent.patients.text12);
            this.patientsContentText13.html(this.languagesJSON.he.PageContent.patients.text13);

            //Payers Content            
            this.payersContentText1.html(this.languagesJSON.he.PageContent.payers.text1);
            this.payersContentText2.html(this.languagesJSON.he.PageContent.payers.text2);
            this.payersContentText3.html(this.languagesJSON.he.PageContent.payers.text3);
            this.payersContentText4.html(this.languagesJSON.he.PageContent.payers.text4);
            this.payersContentText5.html(this.languagesJSON.he.PageContent.payers.text5);
            this.payersContentText6.html(this.languagesJSON.he.PageContent.payers.text6);
            this.payersContentText7.html(this.languagesJSON.he.PageContent.payers.text7);
            this.payersContentText8.html(this.languagesJSON.he.PageContent.payers.text8);
            this.payersContentText9.html(this.languagesJSON.he.PageContent.payers.text9);
            this.payersContentText10.html(this.languagesJSON.he.PageContent.payers.text10);

            //Therapy Content
            //Therapy content
            this.therapyContentText1.html(this.languagesJSON.he.PageContent.therapy.text1);
            this.therapyContentText2.html(this.languagesJSON.he.PageContent.therapy.text2);
            this.therapyContentText3.html(this.languagesJSON.he.PageContent.therapy.text3);
            this.therapyContentText4.html(this.languagesJSON.he.PageContent.therapy.text4);
            this.therapyContentText5.html(this.languagesJSON.he.PageContent.therapy.text5);
            this.therapyContentText6.html(this.languagesJSON.he.PageContent.therapy.text6);
            this.therapyContentText7.html(this.languagesJSON.he.PageContent.therapy.text7);
            this.therapyContentText8.html(this.languagesJSON.he.PageContent.therapy.text8);
            this.therapyContentText9.html(this.languagesJSON.he.PageContent.therapy.text9);
            this.therapyContentText10.html(this.languagesJSON.he.PageContent.therapy.text10);
            this.therapyContentText11.html(this.languagesJSON.he.PageContent.therapy.text11);
            this.therapyContentText12.html(this.languagesJSON.he.PageContent.therapy.text12);
            this.therapyContentText13.html(this.languagesJSON.he.PageContent.therapy.text13);
            this.therapyContentText14.html(this.languagesJSON.he.PageContent.therapy.text14);
            this.therapyContentText15.html(this.languagesJSON.he.PageContent.therapy.text15);
            this.therapyContentText16.html(this.languagesJSON.he.PageContent.therapy.text16);
            this.therapyContentText17.html(this.languagesJSON.he.PageContent.therapy.text17);
            this.therapyContentText18.html(this.languagesJSON.he.PageContent.therapy.text18);

            //Message System
            this.form_container.attr("dir","rtl");
            this.messageSystemText1.html(this.languagesJSON.he.MessageSystem.text1);            
            this.messageSystemText2.html(this.languagesJSON.he.MessageSystem.text2);
            this.messageSystemText3.html(this.languagesJSON.he.MessageSystem.text3);
            this.messageSystemText4.html(this.languagesJSON.he.MessageSystem.text4);
            this.messageSystemText5.html(this.languagesJSON.he.MessageSystem.text5);
            this.SendMessage.html(this.languagesJSON.he.MessageSystem.text6);
 
        }  
        if (window.location.hash == "#spa") {


          //Images Buttons
          this.ImgGetStartedNowButtonAllied.prop("src", this.ImgGetStartedNowButtonAllied.attr("src")+".spa.jpg");
          this.ImgGetStartedNowButtonPatients.prop("src", this.ImgGetStartedNowButtonPatients.attr("src")+".spa.jpg");
          this.ImgGetStartedNowButtonPayers.prop("src", this.ImgGetStartedNowButtonPayers.attr("src")+".spa.jpg");
          this.ImgSignInButton.prop("src", this.ImgSignInButton.attr("src")+".spa.jpg");
          this.ImgLearnHowWeCanHelp.prop("src", this.ImgLearnHowWeCanHelp.attr("src")+".spa.jpg");
          

          //Top Left IBDSF Logo
          this.ibdsf_top_left_logo.prop("href", this.homeMenuLink.attr("href")+"#spa");

          //MenuItems--------------------------------------------------
          this.homeMenuLink.text(this.languagesJSON.spa.MenuLinks.homeMenuLink);
          this.homeMenuLink.prop("href", this.homeMenuLink.attr("href")+"#spa");

          this.aboutUsMenuLink.text(this.languagesJSON.spa.MenuLinks.aboutUsMenuLink);
          this.aboutUsMenuLink.prop("href", this.aboutUsMenuLink.attr("href")+"#spa");

          this.servicesMenuLink.text(this.languagesJSON.spa.MenuLinks.servicesMenuLink);            

          this.individualTherapyMenuLink.text(this.languagesJSON.spa.MenuLinks.individualTherapyMenuLink);
          this.individualTherapyMenuLink.prop("href", this.individualTherapyMenuLink.attr("href")+"#spa");

          this.testimonialsMenuLink.text(this.languagesJSON.spa.MenuLinks.testimonialsMenuLink);
          this.testimonialsMenuLink.prop("href", this.testimonialsMenuLink.attr("href")+"#spa");

          this.contactMenuLink.text(this.languagesJSON.spa.MenuLinks.contactMenuLink);
          this.contactMenuLink.prop("href", this.contactMenuLink.attr("href")+"#spa");

          this.languagesMenuLink.text(this.languagesJSON.spa.MenuLinks.language);
          this.EnglishlanguageMenuLink.text(this.languagesJSON.spa.MenuLinks.englishLang);
          this.HebrewlanguageMenuLink.text(this.languagesJSON.spa.MenuLinks.hebrewLang);
          this.SpanishlanguageMenuLink.text(this.languagesJSON.spa.MenuLinks.spanishLang);

        
          //PageBannerText--------------------------------------------------
          this.pageBannerText.html("<h2 class='headline--medium'>"+ 
            this.languagesJSON.spa.pageBannerText.text1 + 
              "</br>"+
            this.languagesJSON.spa.pageBannerText.text2 + 
              "</br>" + 
            this.languagesJSON.spa.pageBannerText.text3 + 
              "</br>" + 
              this.languagesJSON.spa.pageBannerText.text4 + 
              "</br>" + 
              this.languagesJSON.spa.pageBannerText.text5 + 
            " </h2>");

          //Middle Section Header
            this.middleSectionHeaderAllied.html("<p class='t-center'>" + this.languagesJSON.spa.middleSectionHeader.allied + "</p>");
            this.middleSectionHeaderPatients.html("<p class='t-center'>" + this.languagesJSON.spa.middleSectionHeader.patients + "</p>");
            this.middleSectionHeaderPayers.html("<p  class='t-center'>" + this.languagesJSON.spa.middleSectionHeader.payers.text1 + "</br>" + this.languagesJSON.spa.middleSectionHeader.payers.text2 + "</p>");


          //Middle Section Body
            
            this.middleSectionBodyAllied.html("<p>" + this.languagesJSON.spa.middleSectionBody.allied.text1 + "</p><br><br><p>" + this.languagesJSON.spa.middleSectionBody.allied.text2 + "</p>");            
            this.middleSectionBodyPatients.html("<p>" + this.languagesJSON.spa.middleSectionBody.patients.text1 + "</p><br><br><p>" + this.languagesJSON.spa.middleSectionBody.patients.text2 + "</p><br><br><p>" + this.languagesJSON.spa.middleSectionBody.patients.text3 + "</p>");
            this.middleSectionBodyPayers.html("<p>" + this.languagesJSON.spa.middleSectionBody.payers.text1 + "</p><br><br><p>" + this.languagesJSON.spa.middleSectionBody.payers.text2 + "</p>");
            
            this.middleSectionFootAlliedLink.prop("href", this.middleSectionFootAlliedLink.attr("href")+"#spa");
            this.middleSectionFootPatientsLink.prop("href", this.middleSectionFootPatientsLink.attr("href")+"#spa");
            this.middleSectionFootPayersLink.prop("href", this.middleSectionFootPayersLink.attr("href")+"#spa");

          //Middle Section Footer          
          this.middleSectionFootAllied.html(this.languagesJSON.spa.middleSectionFoot.allied.text1);          
          this.middleSectionFootPatients.html(this.languagesJSON.spa.middleSectionFoot.patients.text1);          
          this.middleSectionFootPayers.html(this.languagesJSON.spa.middleSectionFoot.payers.text1);

          //Footer Connect          
          this.footerConnect.html(this.languagesJSON.spa.Footer.connect);

          //Page Content
          

          //Page Banner
          this.pageBannerAboutUsTitle.html(this.languagesJSON.spa.PageBanner.aboutUs.text1);
          this.pageBannerAlliedTitle.html(this.languagesJSON.spa.PageBanner.allied.text1 + "</br>&nbsp;" + this.languagesJSON.spa.PageBanner.allied.text2);
          this.pageBannerPatientsTitle.html(this.languagesJSON.spa.PageBanner.patients.text1);
          this.pageBannerPayersTitle.html(this.languagesJSON.spa.PageBanner.payers.text1 + " &nbsp;</br>&nbsp;" + this.languagesJSON.spa.PageBanner.payers.text2);
          this.pageBannerPayersIntroTitle.html(this.languagesJSON.spa.PageBanner.payers.text3);

          this.pageBannerContactUsTitle.html(this.languagesJSON.spa.PageBanner.contactus.text1);
          
         
          this.pageBannerTherapyTitle.html(this.languagesJSON.spa.PageBanner.therapy.text1);
          
          

          //AboutUs
          this.AboutUsText1.html(this.languagesJSON.spa.PageContent.aboutUs.AboutUsText1);
          this.AboutUsText2.html(this.languagesJSON.spa.PageContent.aboutUs.AboutUsText2);
          this.AboutUsText3.html(this.languagesJSON.spa.PageContent.aboutUs.AboutUsText3);
          this.AboutUsText4.html(this.languagesJSON.spa.PageContent.aboutUs.AboutUsText4);
          this.AboutUsText5.html(this.languagesJSON.spa.PageContent.aboutUs.AboutUsText5);
          this.AboutUsText6.html(this.languagesJSON.spa.PageContent.aboutUs.AboutUsText6);
          this.AboutUsText7.html(this.languagesJSON.spa.PageContent.aboutUs.AboutUsText7);

          //Allied Content
          this.alliedContentText1.html(this.languagesJSON.spa.PageContent.allied.text1);
          this.alliedContentText2.html(this.languagesJSON.spa.PageContent.allied.text2);
          this.alliedContentText3.html(this.languagesJSON.spa.PageContent.allied.text3);
          this.alliedContentText4.html(this.languagesJSON.spa.PageContent.allied.text4);
          this.alliedContentText5.html(this.languagesJSON.spa.PageContent.allied.text5);
          this.alliedContentText6.html(this.languagesJSON.spa.PageContent.allied.text6);
          this.alliedContentText7.html(this.languagesJSON.spa.PageContent.allied.text7);
          this.alliedContentText8.html(this.languagesJSON.spa.PageContent.allied.text8);
          this.alliedContentText9.html(this.languagesJSON.spa.PageContent.allied.text9);
          this.alliedContentText10.html(this.languagesJSON.spa.PageContent.allied.text10);
          this.alliedContentText11.html(this.languagesJSON.spa.PageContent.allied.text11);
          this.alliedContentText12.html(this.languagesJSON.spa.PageContent.allied.text12);


          //Patients Content 
          this.patientsContentText1.html(this.languagesJSON.spa.PageContent.patients.text1);
          this.patientsContentText2.html(this.languagesJSON.spa.PageContent.patients.text2);
          this.patientsContentText3.html(this.languagesJSON.spa.PageContent.patients.text3);
          this.patientsContentText4.html(this.languagesJSON.spa.PageContent.patients.text4);
          this.patientsContentText5.html(this.languagesJSON.spa.PageContent.patients.text5);
          this.patientsContentText6.html(this.languagesJSON.spa.PageContent.patients.text6);
          this.patientsContentText7.html(this.languagesJSON.spa.PageContent.patients.text7);
          this.patientsContentText8.html(this.languagesJSON.spa.PageContent.patients.text8);
          this.patientsContentText9.html(this.languagesJSON.spa.PageContent.patients.text9);
          this.patientsContentText10.html(this.languagesJSON.spa.PageContent.patients.text10);
          this.patientsContentText11.html(this.languagesJSON.spa.PageContent.patients.text11);
          this.patientsContentText12.html(this.languagesJSON.spa.PageContent.patients.text12);
          this.patientsContentText13.html(this.languagesJSON.spa.PageContent.patients.text13);

          //Payers Content            
          this.payersContentText1.html(this.languagesJSON.spa.PageContent.payers.text1);
          this.payersContentText2.html(this.languagesJSON.spa.PageContent.payers.text2);
          this.payersContentText3.html(this.languagesJSON.spa.PageContent.payers.text3);
          this.payersContentText4.html(this.languagesJSON.spa.PageContent.payers.text4);
          this.payersContentText5.html(this.languagesJSON.spa.PageContent.payers.text5);
          this.payersContentText6.html(this.languagesJSON.spa.PageContent.payers.text6);
          this.payersContentText7.html(this.languagesJSON.spa.PageContent.payers.text7);
          this.payersContentText8.html(this.languagesJSON.spa.PageContent.payers.text8);
          this.payersContentText9.html(this.languagesJSON.spa.PageContent.payers.text9);
          this.payersContentText10.html(this.languagesJSON.spa.PageContent.payers.text10);

          //Therapy Content
          //Therapy content
          this.therapyContentText1.html(this.languagesJSON.spa.PageContent.therapy.text1);
          this.therapyContentText2.html(this.languagesJSON.spa.PageContent.therapy.text2);
          this.therapyContentText3.html(this.languagesJSON.spa.PageContent.therapy.text3);
          this.therapyContentText4.html(this.languagesJSON.spa.PageContent.therapy.text4);
          this.therapyContentText5.html(this.languagesJSON.spa.PageContent.therapy.text5);
          this.therapyContentText6.html(this.languagesJSON.spa.PageContent.therapy.text6);
          this.therapyContentText7.html(this.languagesJSON.spa.PageContent.therapy.text7);
          this.therapyContentText8.html(this.languagesJSON.spa.PageContent.therapy.text8);
          this.therapyContentText9.html(this.languagesJSON.spa.PageContent.therapy.text9);
          this.therapyContentText10.html(this.languagesJSON.spa.PageContent.therapy.text10);
          this.therapyContentText11.html(this.languagesJSON.spa.PageContent.therapy.text11);
          this.therapyContentText12.html(this.languagesJSON.spa.PageContent.therapy.text12);
          this.therapyContentText13.html(this.languagesJSON.spa.PageContent.therapy.text13);
          this.therapyContentText14.html(this.languagesJSON.spa.PageContent.therapy.text14);
          this.therapyContentText15.html(this.languagesJSON.spa.PageContent.therapy.text15);
          this.therapyContentText16.html(this.languagesJSON.spa.PageContent.therapy.text16);
          this.therapyContentText17.html(this.languagesJSON.spa.PageContent.therapy.text17);
          this.therapyContentText18.html(this.languagesJSON.spa.PageContent.therapy.text18);

          //Message System
          
          this.messageSystemText1.html(this.languagesJSON.spa.MessageSystem.text1);            
          this.messageSystemText2.html(this.languagesJSON.spa.MessageSystem.text2);
          this.messageSystemText3.html(this.languagesJSON.spa.MessageSystem.text3);
          this.messageSystemText4.html(this.languagesJSON.spa.MessageSystem.text4);
          this.messageSystemText5.html(this.languagesJSON.spa.MessageSystem.text5);
          this.SendMessage.html(this.languagesJSON.spa.MessageSystem.text6);

      }  
    }

  }

  // 3.- methods (function, action...)
  reloadPageEng(){
    location.hash = "eng";
    location.reload();
  }

  reloadPageHeb(){
    location.hash = "he";
    location.reload();
  }

  reloadPageSpa(){
    location.hash = "spa";
    location.reload();
  }
  
}



export default Languages;